import { Box, CircularProgress, Typography } from "@mui/material";
import { InfoSection } from "../shared/InfoSection";
import { usePersonSections } from "./usePersonSections";
import { useAdSections } from "../active_directory/useAdSections";

const WSU_RED = "#A60F2D";

// Past this length, a value wraps into enough lines at the base tile width
// that giving the tile a second column reads much better.
const WIDE_TILE_THRESHOLD = 60;
const spanFor = (maxLength) => (maxLength > WIDE_TILE_THRESHOLD ? 2 : 1);

const LoadingTile = () => (
    <Box sx={{ gridColumn: "1 / -1" }} display="flex" justifyContent="center" alignItems="center" minHeight={200}>
        <CircularProgress style={{ color: WSU_RED }} size={64} thickness={5} />
    </Box>
);

const ErrorTile = ({ message }) => (
    <Box sx={{ gridColumn: "1 / -1", backgroundColor: WSU_RED, color: "white", px: 3, py: 2, borderRadius: 2 }}>
        <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 0.5 }}>Failed to load data</Typography>
        <Typography variant="body2">{message || "Unknown error occurred"}</Typography>
    </Box>
);

export const UserDetailPanel = ({ identifier }) => {
    const person = usePersonSections(identifier);
    const ad = useAdSections();

    // Widest/longest tiles are placed first so the dense grid packs the
    // remaining, narrower tiles into the gaps they'd otherwise leave behind.
    const tiles = [...person.tiles, ...ad.tiles].sort((a, b) => b.maxLength - a.maxLength);

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                gridAutoFlow: "dense",
                gap: 3,
                alignItems: "start",
                width: "100%",
            }}
        >
            {!person.isLoaded && <LoadingTile />}
            {person.error && <ErrorTile message={person.error.message} />}
            {!ad.isLoaded && <LoadingTile />}
            {ad.error && <ErrorTile message={ad.error.message} />}
            {tiles.map((tile) => (
                <InfoSection key={tile.key} heading={tile.heading} rows={tile.rows} span={spanFor(tile.maxLength)} />
            ))}
        </Box>
    );
};
